module.exports = __webpack_public_path__ + "static/img/pro6_tab2.c7a8b60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro6_tab2.jpg
// module id = WMZy
// module chunks = 171